import { api, TAGS } from "@/store/api"
import { ILeaderboardReq, ILeaderboardRes, IPlayer } from "@/types/player.types"

export const playerAPI = api
  .enhanceEndpoints({ addTagTypes: [TAGS.PLAYER] })
  .injectEndpoints({
    endpoints: (build) => ({
      getMe: build.query<IPlayer, void>({
        query: () => ({ url: "/player/me", method: "GET" }),
        providesTags: [TAGS.PLAYER]
      }),
      getLeaderboard: build.query<ILeaderboardRes, ILeaderboardReq>({
        query: (params) => ({ url: "/player", method: "GET", params })
      })
    })
  })

export const { useGetMeQuery, useGetLeaderboardQuery } = playerAPI
